import listViewStore from 'owa-mail-list-store/lib/store/Store';
export default {
    MailListItemAttachmentPreviewDatapoint: {
        datapoint: {
            name: 'MailListItemAttachmentPreview',
            customData: function (totalNumberOfAttachmentPreviews, numOfDocs, numOfImages, previewViewState) { return [
                totalNumberOfAttachmentPreviews,
                previewViewState.numDocToShow +
                    previewViewState.numImageToShow /* total number of previews to show */,
                numOfDocs,
                numOfImages,
                previewViewState.numDocToShow,
                previewViewState.numImageToShow,
                previewViewState.shouldShowPlusMore,
            ]; },
        },
    },
    mailListItemClickedDatapoint: {
        datapoint: {
            name: 'MailListItemClicked',
            customData: function (evt, selectionSource, rowKey, tableViewId) {
                var tableView = listViewStore.tableViews.get(tableViewId);
                var isSwitchGroupConversation = tableView.tableQuery.type == 2 /* Group */ &&
                    tableView.selectedRowKeys.size == 1;
                return [
                    selectionSource,
                    tableView.tableQuery.listViewType,
                    isSwitchGroupConversation,
                ];
            },
        },
    },
    MailListCondensedRowExpanded: {
        datapoint: {
            name: 'MailListCondensedRowExpanded',
        },
    },
};
//# sourceMappingURL=datapoints.js.map